<template>
  <div
    class="app-radio"
    role="radiogroup"
  >
    <div class="app-radio__inner">
      <!-- Radio -->
      <div
        :id="id"
        class="app-radio__check"
        :class="[borderColorClass(400), textColorClass()]"
        tabindex="0"
        role="radio"
        :name="name"
        :aria-checked="checked"
        :aria-labelledby="`label-${labelId}`"
        @click="$emit('input', value)"
        @keypress.space="$emit('input', value)"
      >
        <FontAwesomeIcon
          v-show="checked"
          icon="check"
          class="app-radio__icon"
        />
      </div>

      <!-- Label-->
      <div
        v-if="label"
        :id="`label-${labelId}`"
        class="app-radio__label"
        @click="$emit('input', value)"
      >
        {{ label }}
      </div>
    </div>

    <div
      v-if="error"
      class="app-radio__error"
    >
      {{ error }}
    </div>
  </div>
</template>

<script>
import theme from '@/mixins/theme'

export default {
  // Name
  name: 'AppRadio',

  // Mixins
  mixins: [theme],

  // Props
  props: {
    label: {
      type: String,
      default: ''
    },

    name: {
      type: String,
      default: ''
    },

    id: {
      type: String,
      default: ''
    },

    error: {
      type: String,
      default: ''
    },

    value: {
      type: [String, Number],
      default: ''
    },

    checked: {
      type: Boolean,
      default: false
    }
  },

  // Data
  data () {
    return {
      labelId: null
    }
  },

  mounted () {
    this.labelId = this._uid
  }
}
</script>

<style scoped lang="scss">
.app-radio {
  @apply relative;

  &__inner {
    @apply flex items-center;
  }

  &__check {
    @apply rounded-full flex-shrink-0 w-35 h-35 cursor-pointer;
    @apply border-2 flex justify-center items-center;
  }

  &__icon {
    @apply h-15 w-15 text-base block flex-1 text-center outline-none;
  }

  &__label {
    @apply top-[-5px] text-base pl-15 cursor-pointer;

    p,
    a {
      font-size: inherit;
      line-height: inherit;
    }
  }

  &__error {
    @apply block font-semibold pl-50 text-red-400 text-sm;
  }
}
</style>
